var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBorderAll(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 448 512",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M416 32H32C14.326 32 0 46.326 0 64V448C0 465.674 14.326 480 32 480H416C433.674 480 448 465.674 448 448V64C448 46.326 433.674 32 416 32ZM16 64C16 55.178 23.178 48 32 48H216V248H16V64ZM32 464C23.178 464 16 456.822 16 448V264H216V464H32ZM432 448C432 456.822 424.822 464 416 464H232V264H432V448ZM232 248V48H416C424.822 48 432 55.178 432 64V248H232Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBorderAll);
export default __webpack_public_path__ + "static/media/border-all.4ca9d2fded3a4e11345f7ac59b1ef99c.svg";
export { ForwardRef as ReactComponent };